import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import Form from "../../components/forms/OneFieldForm";
import { rejectRequest, withRedirect } from "../../CroActions";
import { breadcrumbs } from "../../../../actions/appActions";

const mapStateToProps = (state, { params }) => ({
  breadcrumbsItems: [
    { label: "Žádosti o nahlédnutí na neveřejné oznámení" },
    { label: "Zamítnout žádost o nahlédnutí na neveřejné oznámení" },
  ],
  initialValues: { id: params.id },
  submitLabel: "Zamítnout",
  title: "Důvod",
  name: "reason",
  multiline: true,
});

const onSubmit = withRedirect(rejectRequest, "/spravce/zadosti");

export default connect(mapStateToProps, { onSubmit, breadcrumbs, goBack })(
  Form,
);
